import { Component, OnInit } from '@angular/core';
import { RequestMessageInfo } from '../../services/appt-request-tasks';
import { ModalController } from '@ionic/angular';
import { Util } from '../../services/util';

@Component({
  selector: 'app-appt-request-alert',
  templateUrl: './appt-request-alert.page.html',
  styleUrls: ['./appt-request-alert.page.scss'],
})
export class ApptRequestAlertPage implements OnInit {

  info: RequestMessageInfo

  constructor(
    private modalCtrl: ModalController,
  ) { }

  ngOnInit() {
  }

  openChatPressed() {
    this.modalCtrl.dismiss({ roomID: this.info.roomID })
  }

  ignorePressed() {
    this.modalCtrl.dismiss()
  }

  formatDate() {
    return Util.dayMonthDate(this.info.startTime, { offset: this.info.timezoneOffset, abbr: '' })
  }

}
